/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/instagram_medium'
export default icon
